import { render, staticRenderFns } from "./cModalAddPatient.vue?vue&type=template&id=b3908556"
import script from "./cModalAddPatient.vue?vue&type=script&lang=js"
export * from "./cModalAddPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports